import LocationsIndex from "@page-containers/locations";

export default LocationsIndex;
